export interface RepaymentEstimationEntry {
  amountFinance: string;
  month24: string;
  month36: string;
  month48: string;
  month60: string;
}

